import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6pbo2noiib: FaireBrandEntity = {
  token: "b_6pbo2noiib",
  type: "brand",
  name: "www.ilybean.com",
  avatarUrl:
    "https://cdn.faire.com/fastly/dffdc1aad7ffabc69a2d97d09618ef4336ce76533a6c888109c060e1d6d4be4e.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1509365c0553e47c05da672b89c52c75f68154807d42317ae254b40aad8de101.png",
  logoUrl:
    "https://cdn.faire.com/fastly/dffdc1aad7ffabc69a2d97d09618ef4336ce76533a6c888109c060e1d6d4be4e.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1509365c0553e47c05da672b89c52c75f68154807d42317ae254b40aad8de101.png",
  location: "Orlando, FL, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 55,
  isInsider: true,
  description:
    "Thank you for supporting a WOMAN OWNED and operated small business. We are a small team of talented and creative women based in Orlando, Florida.  ilybean newborn nursery beanies are made from 100% authentic hospital hat material with a rounded top to ensure the perfect fit. Our beanies are made from a two ply fabric which make them two times thicker and two times warmer then average hospital beanies. Our newborn beanies make the perfect gift for your newborn or an expectant mom. Let your baby stand out in the nursery and in first photos wearing a stylish nursery beanie from ilybean nursery beanies. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:41.663Z",
    importedBy: "entity-db-cli",
  },
};
